"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnouncementBox = void 0;

var _reactFeedback = require("@cimpress-technology/react-feedback");

var React = _interopRequireWildcard(require("react"));

var _definitions = require("../model/definitions");

var _reactComponents = require("@cimpress/react-components");

var _i18n = require("../../hooks/i18n");

var _consts = require("../../consts");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  showInlineFeedback: false,
  showTopics: true
};

const renderAnnouncementTopics = (t, tags, topics) => {
  let formattedTopics;

  if (topics) {
    formattedTopics = topics.map(topic => /*#__PURE__*/React.createElement(_reactComponents.Label, {
      type: "info",
      key: topic,
      text: t(`topicNames_${topic}`)
    }));
  } else if (tags && tags.length) {
    formattedTopics = tags.map(({
      key,
      value = ''
    }) => /*#__PURE__*/React.createElement(_reactComponents.Label, {
      type: "info",
      key: key,
      text: value
    }));
  } // @ts-ignore


  return formattedTopics ? formattedTopics : null;
};

const renderAnnouncementWithTitleAndSnippet = (t, announcement, language, showTopics) => {
  if (!announcement) {
    return null;
  }

  const {
    tags,
    topics
  } = announcement;
  const title = announcement.title ? announcement.title[language || 'en'] || announcement.title.en : 'title-n/a';
  const snippet = announcement.snippet ? announcement.snippet[language || 'en'] || announcement.snippet.en : 'snippet-n/a';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-child"
  }, /*#__PURE__*/React.createElement("h5", null, title)), /*#__PURE__*/React.createElement("div", {
    className: "flex-child-grow"
  }, "\xA0"), showTopics ? /*#__PURE__*/React.createElement("div", {
    className: "flex-child"
  }, renderAnnouncementTopics(t, tags || [], topics || [])) : null), /*#__PURE__*/React.createElement("div", null, snippet));
};

const AnnouncementBox = ({
  accessToken,
  language,
  announcement,
  showInlineFeedback,
  showTopics,
  showReadMore,
  loudspeakerEnv,
  sessionId
}) => {
  var _announcement$title;

  const {
    tt
  } = (0, _i18n.useDoubleTTranslation)(language);
  const baseUiUrl = loudspeakerEnv === _definitions.ServiceEnvironment.Production ? _consts.LOUDSPEAKER_UI_PRODUCTION : _consts.LOUDSPEAKER_UI_STAGING;
  const readMoreLink = /*#__PURE__*/React.createElement("a", {
    href: `${baseUiUrl}/channels/${announcement.channelId}/announcements/${announcement.announcementId}`,
    target: "_blank",
    rel: "noopener noreferrer"
  }, tt('readMoreAllAnnouncementsLink'));
  return /*#__PURE__*/React.createElement("div", {
    className: "loudspeakerAnnouncement"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'snippet-container'
  }, renderAnnouncementWithTitleAndSnippet(tt, announcement, language, showTopics)), /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex-child'
  }, showReadMore ? readMoreLink : null), /*#__PURE__*/React.createElement("div", {
    className: 'flex-child-grow'
  }, "\xA0"), /*#__PURE__*/React.createElement("div", {
    className: 'flex-child'
  }, showInlineFeedback ? /*#__PURE__*/React.createElement(_reactFeedback.InlineFeedback, {
    accessToken: accessToken,
    language: language,
    campaignId: "e6bfa058-11df-11eb-a2bb-0a6d98ccf6f1",
    questionId: "f3061824-11df-11eb-a2bb-0a6d98ccf6f1",
    extraFeedbackData: {
      announcementId: announcement.announcementId,
      announcementTitle: ((_announcement$title = announcement.title) === null || _announcement$title === void 0 ? void 0 : _announcement$title.en) || ''
    },
    sessionId: sessionId
  }) : null)));
};

exports.AnnouncementBox = AnnouncementBox;
AnnouncementBox.defaultProps = defaultProps;